__turbopack_context__.v({
  "collapse": "HeaderBio-module__ambhVq__collapse",
  "container": "HeaderBio-module__ambhVq__container",
  "expander": "HeaderBio-module__ambhVq__expander",
  "fadeInItems": "HeaderBio-module__ambhVq__fadeInItems",
  "spacing--lg": "HeaderBio-module__ambhVq__spacing--lg",
  "spacing--md": "HeaderBio-module__ambhVq__spacing--md",
  "spacing--sm": "HeaderBio-module__ambhVq__spacing--sm",
  "spacing--xl": "HeaderBio-module__ambhVq__spacing--xl",
  "spacing--xs": "HeaderBio-module__ambhVq__spacing--xs",
  "spacing--xxl": "HeaderBio-module__ambhVq__spacing--xxl",
  "spacing--xxs": "HeaderBio-module__ambhVq__spacing--xxs",
  "spacing--xxxl": "HeaderBio-module__ambhVq__spacing--xxxl",
  "spacing--xxxs": "HeaderBio-module__ambhVq__spacing--xxxs",
  "wrapper": "HeaderBio-module__ambhVq__wrapper",
});
